import * as React from 'react';
import * as typestyle from 'typestyle';
import { colors } from '../../ap/base/styles';

/**
 * The project name component
 * NOTE: Also keep in sync with the page title in index.html
 */
namespace ProjectNameStyles {
  export const rootClassName = typestyle.style({
    display: 'inline-block',
    color: colors.grey,
    fontSize: '18px'
  })
}

export const ProjectName = () =>
  <div className={ProjectNameStyles.rootClassName}>
    Do It Yourself Verification Of Identity for Property Transfers
  </div>
